export const initialPasswordChangeValues = {
  oldPassword: '',
  newPassword1: '',
  newPassword2: '',
}

export const passwordChangeFieldLabels = {
  old_password: 'Старый пароль',
  new_password1: 'Новый пароль',
  new_password2: 'Подтверждение пароля',
  __all__: 'Ошибка',
} as const
